import { useRef, Suspense, lazy } from "react";
import classNames from "classnames";
import VideoCard from "../video-card";
import ArrowBtn from "./elements/arrow-btn";
import WidgetTitle from "./elements/widget-title";
import { useOutletContext } from "react-router-dom";

const Slider = lazy(() => import("react-slick"));

const VideoList = ({ data, title }) => {
  const { sideHubMenu } = useOutletContext() || { sideHubMenu: null };
  const ref = useRef();

  const settings = {
    infinite: false,
    slidesToShow: Math.min(3, data?.length),
    slidesToScroll: 1,
    dots: true,
    prevArrow: <ArrowBtn containerRef={ref} />,
    nextArrow: <ArrowBtn containerRef={ref} />,
    responsive: [
      {
        breakpoint: 9999,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 990 + (sideHubMenu ? 344 : 0),
        settings: {
          slidesToShow: Math.min(2, data?.length),
        },
      },
      {
        breakpoint: 575 + (sideHubMenu ? 344 : 0),
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: data?.length > 1 ? "16px" : "0",
        },
      },
      sideHubMenu && {
        breakpoint: 767,
        settings: {
          slidesToShow: Math.min(2, data?.length),
        },
      },
      sideHubMenu && {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: data?.length > 1 ? "16px" : "0",
        },
      },
    ].filter(Boolean),
  };

  return (
    !!data?.length && (
      <section className={classNames("widget video-list", !title && "no-title")}>
        <WidgetTitle title={title} arrowsRef={ref} />
        <div className="video-list__content">
          <Suspense>
            <Slider
              className={classNames(
                "widget__slider widget__slider--full-width",
                `widget__slider--${data?.length}-slides`
              )}
              {...settings}
            >
              {data?.slice(0, 3).map((item, i) => (
                <VideoCard item={item} key={i} />
              ))}
            </Slider>
          </Suspense>
        </div>
      </section>
    )
  );
};

export default VideoList;
